import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { useSelector } from 'react-redux';

import { media } from '../../../styleHelpers/breakpoint';
import { isGiftContext } from '../../../tools/pathContext';
import { EPlatformPermissions } from '../../../entities/IPermissions';
import { IState } from '../../../reducers';
import { IProfileReducer } from '../../../reducers/profileReducer';
import { colorStack } from '../../../styleHelpers/colors';
import { fontSize } from '../../../styleHelpers/fontSizes';
import IntlMessage from '../IntlMessage';

interface IMainWrapperProps {
    fullWidth?: boolean;
    menuHidden?: boolean;
    isOrg?: boolean;
    fillOrgContainer?: boolean;
    hideProfileSummar?: boolean;
    permissionContext?: EPlatformPermissions;
    children?: ReactNode;
}

const Wrapper = styled.div<IMainWrapperProps>`
    position: relative;
    max-width: 1280px;
    display: flex;
    flex-direction: column;
    margin: auto;
    ${props => props.fullWidth && css`
        max-width: 100%;
    `}
    ${media.desktop`
        padding: 0;
        flex-direction: row;
        ${props => props.fillOrgContainer && css`
            max-width: 100%;
        `}
    `}
`;

const Children = styled.div<{isPersonal: boolean; hideProfileSummar: boolean}>`
    width: 100%;
    ${props => (props.isPersonal) && css`
        ${media.desktop`
            width: calc(100% - 270px - 1rem);
            margin: 0 0 0 1rem;
            ${props.hideProfileSummar && css`
                width: 100%;
                margin: 0;
            `}
        `}
    `}
`;

const NoPermissions = styled.div`
    color: ${colorStack.disabled};
    font-size: ${fontSize[16]};
    display: flex;
    justify-content: center;
    margin: 2rem 0;
`;

const PageWrapper: FC<React.PropsWithChildren<IMainWrapperProps>> = ({ permissionContext, fullWidth, menuHidden, children, fillOrgContainer }) => {
    const location = window.location;
    const params = new URLSearchParams(window.location.search);
    const isGift = isGiftContext(location.pathname);
    const { currentUserPermissions } = useSelector<IState, IProfileReducer>(state => state.profile);

    return (
        <Wrapper fullWidth={fullWidth} menuHidden={menuHidden} fillOrgContainer={fillOrgContainer} isOrg={location.pathname.split('/').indexOf('orgs') > -1}>
            <Children isPersonal={!params.get('organization') || isGift} hideProfileSummar>
                {(currentUserPermissions?.[permissionContext] || typeof permissionContext === 'undefined') ? (
                    <>
                        {children}
                    </>
                ) : (
                    <NoPermissions>
                        <IntlMessage id="global.noPermission" />
                    </NoPermissions>
                )}
            </Children>
        </Wrapper>
    );
};

export const MainWrapper = PageWrapper;